






































import { Editor, Extension } from '@tiptap/vue-2'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import CRichTextEditorMenuBar from '~/components/shared/configurable/form/rich-text/CRichTextEditorMenuBar.vue'
import Vue from 'vue'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import CRichTextEditorTextArea from '~/components/shared/configurable/form/rich-text/CRichTextEditorTextArea.vue'
import { PropType } from '@nuxtjs/composition-api'

export default Vue.extend({
  components: {
    CRichTextEditorTextArea,
    CTextArea,
    CRichTextEditorMenuBar
  },
  props: {
    // https://tiptap.scrumpy.io/docs/api/extensions.html
    extensions: {
      type: Array as PropType<Extension[]>,
      required: false,
      default() {
        return []
      }
    },
    value: {
      type: [Object, String],
      default() {
        return {}
      }
    },
    maxLength: {
      type: Number,
      required: false,
      default: 3000
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    textareaPlaceholder: {
      type: String,
      required: false,
      default() {
        return this.$t('all')
      }
    },
    useBubbleMenu: {
      type: Boolean,
      required: false,
      default: false
    },
    editorMinHeightClass: {
      type: String,
      default: '!tw-min-h-72'
    },
    editorMaxHeightClass: {
      type: String,
      default: '!tw-max-h-[500px]'
    }
  },
  data() {
    return {
      editor: null,
      currentExtensions: [],
      fallbackTextarea: false,
      editorLoaded: false
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.editor && this.editor.commands.setContent(val)
      } else {
        this.editor && this.editor.commands.clearContent()
      }
    }
  },
  mounted() {
    this.initializeEditor()
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    async initializeEditor() {
      try {
        this.currentExtensions = await this.getExtensions()
        this.editor = new Editor({
          onInit: this.handleEditorInit,
          onUpdate: this.handleEditorUpdate,
          content: this.value,
          extensions: this.currentExtensions,
          editorProps: {
            attributes: {
              class: `${this.editorMinHeightClass}  ${this.editorMaxHeightClass}`
            }
          }
        })
      } catch (e) {
        this.$logger.captureError(e)
        this.fallbackTextarea = true
      } finally {
        this.editorLoaded = true
      }
    },
    getExtensions() {
      const defaultExtensions = [Document, Paragraph, Text]
      return [...defaultExtensions, ...this.extensions]
    },
    handleEditorInit() {
      this.$emit('init')
    },
    handleEditorUpdate() {
      let html = this.editor.getHTML()
      let json = this.editor.getJSON()

      if (
        JSON.stringify(json) ===
        JSON.stringify({ type: 'doc', content: [{ type: 'paragraph' }] })
      ) {
        json = null
      }

      if (html === '<p></p>') {
        html = null
      }

      this.$emit('input', {
        json,
        html,
        text: this.editor.state.doc.textContent
      })
    },
    onTextareaInput(value: string) {
      this.$emit('input', {
        json: value,
        html: null,
        text: value
      })
    },
    editorFocus() {
      this.$refs.textArea.focus()
    },
    clearContent() {
      this.editor.commands.clearContent(true)
    }
  }
})
